var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('table-positions-component',{attrs:{"data":_vm.positions,"placeholder":_vm.placeholder}}),_c('table-orders-component',{attrs:{"data":_vm.orders,"placeholder":_vm.placeholder}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }